import React from 'react';
import { Droppable, DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';

function DropOverlay({
  provided,
  snapshot,
}: {
  provided: DroppableProvided;
  snapshot: DroppableStateSnapshot;
}) {
  return (
    <div
      ref={provided.innerRef}
      {...provided.droppableProps}
      className={`create-seat-drop-overlay${snapshot.isDraggingOver ? ' dragging-over' : ''}`}
    >
      {provided.placeholder}
    </div>
  );
}

interface AddCanvasserDropZoneProps {
  crewId: number;
  turfId: number | null;
}

export default function AddCanvasserDropZone({ crewId, turfId }: AddCanvasserDropZoneProps) {
  const turfSuffix = turfId != null ? `_${turfId}` : '';

  return (
    <div
      id={`add-canvasser-drop-mat-${crewId}-${turfId ?? 'none'}`}
      className="add-canvasser-drop-mat add-seat-drop-mat visible"
    >
      <div className="drop-text">+ Drop canvasser to add a seat on this turf</div>
      <Droppable droppableId={`create-seat_${crewId}${turfSuffix}`} type="CANVASSER">
        {(provided, snapshot) => <DropOverlay provided={provided} snapshot={snapshot} />}
      </Droppable>
    </div>
  );
}

/** Parse crew/turf from create-seat droppable IDs. */
export function parseCreateSeatDropTarget(droppableId: string): {
  crewId: number;
  turfId: number | null;
} | null {
  const canvasserMatch = droppableId.match(/^create-seat_(\d+)(?:_(\d+))?$/);
  if (canvasserMatch) {
    return {
      crewId: Number(canvasserMatch[1]),
      turfId: canvasserMatch[2] != null ? Number(canvasserMatch[2]) : null,
    };
  }

  const turfMatch = droppableId.match(/^create-seat-turf_(\d+)$/);
  if (turfMatch) {
    return {
      crewId: Number(turfMatch[1]),
      turfId: null,
    };
  }

  return null;
}
